
import { useEffect, useState } from 'react'
import { BACKEND_URL } from 'constants'
import SectionNewspappers from 'components/Sections/SectionNewspappers'

const PageGazety = () => {
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchNewspappers = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/newspappers`)

        if (!response.ok) {
          throw new Error('Błąd pobierania gazet')
        }

        const result = await response.json()

        if (!result.error && Array.isArray(result.result)) {
          setData(result.result)
        }
      } catch (error) {
        console.error('Błąd pobierania gazet:', error)
      }
    }

    fetchNewspappers()
  }, [])

  const visibleNewspappers = data.filter(
    (news) => news?.isVisible === 1
  )

  return (
    <div className="nc-PageArchiveAudio">
      <div className="container lg:pb-28 space-y-16 lg:space-y-28">
        <div>
          <SectionNewspappers
            heading="Gazeta"
            posts={visibleNewspappers}
          />
        </div>
      </div>
    </div>
  )
}

export default PageGazety
